import axios from 'axios';

// Only log timings on the server
const isServer = typeof window === 'undefined';

axios.interceptors.request.use((config) => {
  if (isServer) {
    config.metadata = { startTime: Date.now() };
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

axios.interceptors.response.use((response) => {
  if (isServer && response.config.metadata?.startTime) {
    const duration = Date.now() - response.config.metadata.startTime;
    console.log(`[Server Timing] ${response.config.method?.toUpperCase()} ${response.config.url} took ${duration}ms`);
  }
  return response;
}, (error) => {
  if (isServer && error.config?.metadata?.startTime) {
    const duration = Date.now() - error.config.metadata.startTime;
    console.log(`[Server Timing] ${error.config.method?.toUpperCase()} ${error.config.url} failed after ${duration}ms`);
  }
  return Promise.reject(error);
});